import { z } from 'zod';
import { SPAN_KINDS } from '../../src/domain/teeth/spans';
import { IdSchema, ToothNumberSchema } from './common.schema';

/**
 * A bridge or a titanium bar: a named run of teeth from one tooth to another.
 *
 * `from` and `to` may be named in either order; the run between them follows
 * the arch, so 13 to 23 covers 13, 12, 11, 21, 22, 23. Both must be on the
 * same arch, both must be teeth on the case, and two spans of the same kind
 * may not cover the same tooth. `src/domain/teeth/spans.ts` is the rule book,
 * with the wording the server returns.
 *
 * Its own module rather than a section of `jobOrder.schema.ts`, because the
 * kit carries spans too and the job order schema is built on the kit's;
 * putting this beside the job order would make the two import each other.
 * `jobOrder.schema.ts` re-exports it, so a reader looking there finds it.
 */
export { SPAN_KINDS };

export const SpanSchema = z.object({
  id: IdSchema,
  name: z
    .string()
    .trim()
    .min(1, 'Give the bridge or bar a name')
    .max(60, 'A bridge or bar name is at most 60 characters'),
  kind: z.enum(SPAN_KINDS, { errorMap: () => ({ message: 'Choose bridge or titanium bar' }) }),
  from: ToothNumberSchema,
  to: ToothNumberSchema,
});

/** What the client sends. The server assigns the id. */
export const NewSpanSchema = SpanSchema.omit({ id: true });

export type SpanPayload = z.infer<typeof SpanSchema>;
export type NewSpanPayload = z.infer<typeof NewSpanSchema>;
